
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import MediaPreview from "@/components/Reusable/CustomInputs/MediaInput/MediaPreview.vue";
import Icon from "@/components/UI/Icon.vue";
import { IconName } from "@/lib/icons/icons";
import ColorSwatch from "@/components/Reusable/CustomInputs/Color/ColorSwatch.vue";
import { configStore } from "@/store/store";

@Component({
  components: {
    ColorSwatch,
    Icon,
    MediaPreview,
    Dropdown
  }
})
export default class RepeaterItemMedia extends Vue {
  @Prop({ default: false })
  expanded!: boolean;

  @Prop({ default: false })
  noDuplicate!: boolean;

  @Prop()
  noDisable?: boolean;

  @Prop({ default: false })
  disabled!: boolean;

  @Prop()
  icon?: IconName;

  @Prop()
  color?: string;

  @Prop()
  defaultTitle?: string;

  get maxWidth() {
    return configStore.builderMode === "oxygen" ? 228 : 264;
  }
}
